export default "__VITE_ASSET__D4na2FEj__"